/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from 'react';
import { Box, Button, Typography, Grid, makeStyles } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import Recaptcha from 'react-invisible-recaptcha';
import InputField from '../../custom-components/form-fields/inputField';
import validateFunctions from '../../models/validation';
import { ForgotPasswordSchema } from '../../models/schema';
import projectSetting from 'settings.js';
import { FORGOT_PASSWORD } from 'api-setup/api-endpoints.js';
import { API, POSTAPI } from 'api-setup/api-helper';
import BtnWithLoader from 'custom-components/btnWithLoader';
import { useDispatch } from 'react-redux';
import EmailSentIcon from '../../images/forgot-password-email-sent.png';
import useAuthStyles from './styles';
import VSvgMailIcon from '../../icons/VSvgMailIcon';



// handle change of inputs in formFields
const handleChange = (e, formFields, setFormFields, errorObj, setErrorObj) => {
  const { name, value } = e.target;
  if (errorObj[name]) setErrorObj({ ...errorObj, [name]: '' });
  setFormFields({ ...formFields, [name]: value });
};

// Check for validation of form when login button clicked
function handleValidations(formFields) {
  const { email } = formFields;
  const data = { email: email.trim() };
  const errorObj = validateFunctions.validate(ForgotPasswordSchema, data);
  if (errorObj) {
    return errorObj;
  } else {
    return false;
  }
}

const useStyles = makeStyles((theme) => ({
  iconColor: {
    color: `${theme.palette.text.primary} !important`,
  },
  anchorLink: {
    textDecoration: 'underline',
    fontWeight: 600,
  },
}));

export default function ForgotPassword() {
  const { iconColor, anchorLink } = useStyles();
  const { authBtn, primaryBtn, secondaryBtn, authInputStyles, formContainer, formInputBox, pageContainer, titleBox, titleText } = useAuthStyles();

  const [isEmailSentForVerification, setIsEmailSentForVerification] = useState(false);
  const isEmailVerified = false;
  const [formFields, setFormFields] = useState({
    email: '',
  });
  const [errorObj, setErrorObj] = useState({});
  const [captchaToken, setCaptchaToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const recaptchaRef = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const isCaptchaEnabled = process.env.REACT_APP_ENV_TYPE === 'stg' || process.env.REACT_APP_ENV_TYPE === 'prod';


  useEffect(() => {
    if (captchaToken) {
      const data = {
        ...formFields,
        captchaToken,
      };
      makeAPIcall(
        { data },
        recaptchaRef,
        history,
        setIsEmailSentForVerification,
        setIsLoading,
        dispatch
      );
    }
  }, [captchaToken]);

  const handleSubmit = (e, formField, setErrorObject, reCaptchaRef) => {
    e.preventDefault();
    const errorObject = handleValidations(formField);
    if (!errorObject) {
      setErrorObject({});
      if (isCaptchaEnabled) {
        if (reCaptchaRef && reCaptchaRef.current) {
          reCaptchaRef.current.execute();
        }
      } else {
        const data = {
          ...formField,
          captchaToken,
        };
        makeAPIcall(
          { data },
          reCaptchaRef,
          history,
          setIsEmailSentForVerification,
          setIsLoading,
          dispatch
        );
      }
    } else {
      setErrorObject(errorObject);
    }
  };

  // login API call
  const makeAPIcall = (
    data,
    reCaptchaRef,
    PropHistory,
    PropSetIsEmailSentForVerification,
    propSetIsLoading,
    PropDispatch
  ) => {
    propSetIsLoading(true);
    POSTAPI(false, FORGOT_PASSWORD, null, null, data)
      .then((res) => {
        if (res.data.status === API.apiSuccessStatus) {
          PropSetIsEmailSentForVerification(true);
        } else {
          PropSetIsEmailSentForVerification(false);
          API.errStatusHandler(res, PropHistory, PropDispatch, () => {
            if (isCaptchaEnabled) {
              if (reCaptchaRef && reCaptchaRef.current) reCaptchaRef.current.reset();
            }
          });
        }
        propSetIsLoading(false);
      })
      .catch((err) => {
        propSetIsLoading(false);
        PropSetIsEmailSentForVerification(false);
        API.catchHandler(err, () => {
          if (isCaptchaEnabled) {
            if (reCaptchaRef && reCaptchaRef.current) reCaptchaRef.current.reset();
          }
        });
      });
  };

  return (
    <Box className={pageContainer}>
      <Box className={titleBox}>
        <Typography variant='h2' className={titleText}>
          Forgot Password.
        </Typography>
      </Box>
      <Box className={formContainer}>
        {(isEmailSentForVerification && !isEmailVerified) ? (
          <Box textAlign="center" className={formInputBox}>
            <Box component='img' src={EmailSentIcon}>
            </Box>
            <Box mt={4}>
              <Typography variant="body1" component="p">
                We just sent an email to{' '}
                <Box component="span">
                  {formFields.email}
                </Box>
                . Go check your mailbox, and click in the email to log in instantly to your account.
              </Typography>
            </Box>
          </Box>
        ) : (
          <>
            <form onSubmit={(e) => handleSubmit(e, formFields, setErrorObj, recaptchaRef)}>
              <Box className={formInputBox}>
                <Grid container spacing={2}>
                  {!isEmailVerified ? (
                    <Grid item xs={12}>
                      <InputField
                        disabled={isLoading}
                        className={authInputStyles}
                        required
                        placeholder="Email address"
                        type="email"
                        startAdornment
                        startIconAdornment
                        startAdornmentIcon={<VSvgMailIcon className={iconColor} />}
                        error={errorObj.email}
                        name="email"
                        value={formFields.email}
                        onChange={(e) => {
                          handleChange(e, formFields, setFormFields, errorObj, setErrorObj);
                        }}
                      />
                    </Grid>
                  ) : (
                    <></>
                  )}
                </Grid>
              </Box>
              <Box>
                {!isEmailVerified ? (
                  <BtnWithLoader
                    variant="contained"
                    className={`${authBtn} ${primaryBtn}`}
                    disabled={isLoading}
                    type="submit"
                    isLoading={isLoading}
                    loadingLabel="Requesting"
                    label="Send"
                    fullWidth
                  />
                ) : (
                  <Button className={`${authBtn} ${primaryBtn}`} fullWidth variant="contained">
                    Reset Password
                  </Button>
                )}
              </Box>
            </form>
          </>
        )}
      </Box>
      <Box mt={3.5}>
        <Typography variant="body2" component="p">
          Remembered your password?{' '}
          <Link to="/">
            <Box component="span" color='text.primary' className={anchorLink}>
              Try Logging in
            </Box>
          </Link>
        </Typography>
      </Box>
      {isCaptchaEnabled && (
        <Recaptcha
          ref={recaptchaRef}
          sitekey={projectSetting.recaptchaSiteKey}
          onResolved={(propCaptchaToken) => {
            setCaptchaToken(propCaptchaToken);
          }}
        />
      )}
    </Box>
  );
}
